module.exports = __webpack_public_path__ + "static/media/open-side-menu.cc7c0e60.svg";